export type Coordinates = {
  latitude: number;
  longitude: number;
};

// Before using this function ensure that the google maps SDK has been loaded
const geocode = async (address: string): Promise<Coordinates> => {
  const geocoder = new google.maps.Geocoder();
  const geocodeResults = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) =>
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK') {
        resolve(results!);
      } else {
        reject(new Error(status));
      }
    })
  );
  const location = geocodeResults[0].geometry.location;
  return {
    latitude: location.lat(),
    longitude: location.lng(),
  };
};

export default geocode;
